import Commons from '../../../../Services/Common/Common';

export const M_FILE_BASIC_03_Schema = {
  mapper: {
    search1: {
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd ?? ''),
    },
  },
};
